<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <p :style="{ ...widthStyle, ...heightStyle }" class="text--secondary text-center subtitle-1 ma-0">DevExpress. Web Reporting</p>
  </dr-wrapper>
  <iframe :style="{ ...widthStyle, ...heightStyle }" v-else :src="iframeUrl" frameBorder="0" class="report-iframe" />
</template>

<script>
import baseMixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  mixins: [baseMixin, inputMixin, widgetsWrapperMixin],
  data: () => ({
  }),
 
  computed: {
    iframeUrl() {
      if (!this.model?.ReportId) {
        return ''
      }

      let base = this.$router.options.base
      if (window.location.host.includes('localhost')) {
        base = ''
      }
      base += '/dev-express-reporting-viewer.html'
      base = base.replace('//','/')
      let url = new URL(base, window.location.origin)
      url.searchParams.append('path', this.model.ReportId)
      let params = this.parameters
      url.searchParams.append('rp', params)
      return url.toString()
    },
    widthStyle() {
      if (this.model?.Width) {
        return {
          width: this.model.Width
        }
      }
      return {}
    },
    heightStyle() {
      if (this.model?.Height) {
        return {
          height: this.model.Height
        }
      }
      return {}
    },

    // parameters of the report. it will be added to report URL in form "rp=parameters"
    parameters() {
      var params = this.model?.ReportParameters
      if (!params) {
        return '{}'
      }

      let paramsValues = {}
      for (const property in params) {
        const value = this.getExternalSourceField(params[property])
        paramsValues[property] = value ?? params[property]
      }

      return JSON.stringify(paramsValues)
    }

  }
}
</script>

<style>
.report-iframe {
  width: 100%;
  height: 85%;
}
</style>